/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import HashLoader from "react-spinners/HashLoader"
import jwt_decode from "jwt-decode"
import LoginFailed from "../errorPages/LoginFailed"
let base64 = require("base-64")

const baseURL = process.env.REACT_APP_BASE_URL
const domain = process.env.REACT_APP_AUTH_API_URL

const Loading = () => {
  const isLoggedin = localStorage.getItem("isLoggedin")
  const navigate = useNavigate()

  const [loading, setLoading] = useState(true)
  // const [errormsg, setErrorMsg] = useState([])
  // const [isError,setIsError] = useState(false)

  const codeVerifier = localStorage.getItem("codeVerifier")
  console.log(codeVerifier)
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const paramValue = urlParams.get("code")

  let config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization:
        "Basic " +
        base64.encode(
          process.env.REACT_APP_AUTH_USERNAME +
            ":" +
            process.env.REACT_APP_AUTH_PASSWORD
        ),
    },
  }

  const data = {
    grant_type: "authorization_code",
    redirect_uri: baseURL + "/loading",
    code: paramValue,
    client_id: process.env.REACT_APP_AUTH_USERNAME,
    code_verifier: codeVerifier,
  }

  /*Send the Auth code and code verifier and with above detail to get the token and store in local storage*/
  useEffect(() => {
    setLoading(true)
    if (isLoggedin === "true") {
      navigate("/app/dashboard")
    } else {
      axios
        .post(`${domain}/token`, data, config)
        .then((res) => {
          // setIsError(false)
          console.log(res)
          localStorage.setItem(
            "accessToken",
            JSON.stringify(res?.data.access_token)
          )
          localStorage.setItem(
            "refreshToken",
            JSON.stringify(res?.data.refresh_token)
          )
          localStorage.setItem(
            "DecryptedIdToken",
            JSON.stringify(jwt_decode(res?.data.id_token)) //Decode the id_token using the jwt_decode lib
          )
          localStorage.setItem("isLoggedin", true)

          navigate("/app/dashboard")
        })
        .catch((error) => {
          setLoading(false)
          // localStorage.setItem("isLoggedin", false)
          localStorage.removeItem("userToken")
          // setIsError(true)
          // setErrorMsg(error?.response.data.error)
        })
    }
  }, [])

  return (
    <div className="container">
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <HashLoader color="#116c6f" size={150} loading={loading} />
        {loading === false && <LoginFailed />}
      </div>
    </div>
  )
}
export default Loading
